<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование пользователя" : "Добавление пользователя"'
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab Профиль
      v-tab-item(:transition='false' :reverse-transition='false')
        v-form
          v-container(fluid grid-list-xl)
            v-layout(wrap)
              v-flex(xs12 sm6)
                v-text-field(
                  :error='errors.has("name")'
                  :error-messages='errors.first("name")'
                  v-model='item.name'
                  label='Имя пользователя'
                )
              v-flex(xs6 sm4)
                v-select(
                  v-if='id'
                  :error='errors.has("status")'
                  :error-messages='errors.first("status")'
                  :items='item.statuses'
                  item-text='val'
                  item-value='key'
                  v-model='item.status'
                  label='Статус пользователя'
                )
              v-flex(xs6 sm2)
                s-sex-picker(
                  v-model='item.sex'
                )
              v-flex(xs12 sm4)
                s-phone-input(
                  :error='errors.has("phone")'
                  :error-messages='errors.first("phone")'
                  v-model='item.phone'
                  label='Телефон'
                  :append-outer-icon='item.confirmed_phone ? "done" : ""'
                )
              v-flex(xs12 sm4)
                v-text-field(
                  :error='errors.has("email")'
                  :error-messages='errors.first("email")'
                  v-model='item.email'
                  label='Электронная почта'
                  :append-outer-icon='item.confirmed_email ? "done" : ""'
                )
              v-flex(xs12 sm4)
                v-text-field(
                :error='errors.has("login")'
                :error-messages='errors.first("login")'
                v-model='item.login'
                label='Логин (для менеджеров)'
                )

              v-flex(xs12 sm6)
                v-text-field(
                  :error='errors.has("password")'
                  :error-messages='errors.first("password")'
                  v-model='item.password'
                  autocomplete='new-password'
                  type='password'
                  label='Пароль'
                )
              v-flex(xs12 sm6)
                v-text-field(
                  :error='errors.has("c_password")'
                  :error-messages='errors.first("c_password")'
                  :rules='[v => $rules.passMatch(v, item.password)]'
                  v-model='item.c_password'
                  autocomplete='new-password'
                  type='password'
                  label='Повторите пароль'
                )
          v-container(v-if='id' fluid grid-list-xl)
            v-layout(wrap)
              v-flex(xs12)
                v-toolbar(flat color='white')
                  h3(class='title') Привязанные клиенты
                  v-spacer
                  v-btn(@click='openLinkClientDialog' color='primary' depressed) Добавить
                v-divider
                v-data-table(
                    :loading='isLoading'
                    :headers='headers'
                    :items='clients'
                    hide-actions
                  )
                    template(slot='items' slot-scope='props')
                      tr(class='with-pointer' @click='onEdit(props.item.id)')
                        td(data-label='#ID') {{ props.item.id }}
                        td(data-label='ФИО клиента') {{ props.item.full_name }}
                        td(data-label='Телефон') {{ props.item.phone }}
                        td(data-label='Дата добавления') {{ props.item.created_at | date }}
                        td(class='text-xs-right')
                          v-btn(@click.stop='onUnlinkClient(props.item.id)' icon)
                            v-icon(small) delete_outline
        v-card-actions(class='large')
          v-spacer
          s-back-btn
          v-btn(
            :loading='isLoading'
            @click.native='onSave'
            color='primary'
            depressed
          ) Сохранить
      template(v-if='id')
        v-tab Роль
        v-tab-item(:transition='false' :reverse-transition='false')
          roles-list(
            :user='item'
            :manager='manager'
            @remove='onUserRoleRemove'
          )
          roles-archive(:userId='id' ref='rolesArchive')
      v-tab Организации
      v-tab-item(:transition='false' :reverse-transition='false')
        organizations(:user='item')
  s-link-clients(
    :dialog='clientsDialog'
    @select='onSelectClient'
    @close='clientsDialog = false'
  )
</template>

<script>
// template(v-if='void 0 === id')
import RolesList from './RolesList'
import RolesArchive from './RolesArchive'
import Organizations from './Organizations'

import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  props: ['id'],
  data: () => ({
    item: {},
    manager: {},
    focused: false,
    clientsDialog: false,
    active: 0,
    clients: [],
    headers: [
      { text: '#ID', align: 'left', width: '0%', sortable: false },
      { text: 'ФИО', align: 'left', width: '40%', sortable: false },
      { text: 'Телефон', align: 'right', width: '10%', sortable: false },
      { text: 'Дата добавления', align: 'right', width: '10%', sortable: false },
      { text: '', align: 'left', width: '0%', sortable: false }
    ]

  }),

  components: {
    RolesArchive,
    RolesList,
    Organizations
  },

  async created() {
    this.fetchUser()
  },

  beforeDestroy() {
    this.setClient(null)
  },

  methods: {
    async fetchUser(){
      if (this.id) {
        try {
          let response = (await this.fetchSingle({ id: this.id })).data
          this.item = response.user
          this.clients = response.clients
          this.manager = response.manager
        } catch (e) {
          this.$root.showSnack('Ошибка загрузки пользователя')
        }
      }
    },

    onUserRoleRemove() {
      this.$refs.rolesArchive.fetch()
    },

    async onSelectClient(client) {
      this.clientsDialog = false
      try {
        await this.linkClient({
          client_guid: client.guid,
          user_id: this.item.id
        })
      } catch (e) {
        this.$root.showSnack('Не удалось привязать клиента')
      }
      this.fetchUser()
      this.setClient(client)
      this.$root.setClient(client)
    },

    async onUnlinkClient(linkId) {
      if (await this.$confirm('Вы уверены')) {
        try {
          await this.unlinkClient({
            link_id: linkId,
            user_id: this.item.id
          })
        } catch (e) {
          this.$root.showSnack('Не удалось отвязать клиента')
        }
        this.fetchUser()
        this.setClient(null)
        this.$root.setClient(null)
      }
    },

    async onSave() {
      if (this.isLoading) return

      try {
        let { id, item } = this

        if (id) {
          await this.update({
            data: item,
            id
          })
        } else {
          await this.create({ data: item })
        }

        this.$root.showSnack('Пользователь сохранен')
        this.$router.push({ name: 'Admin.Users' })
      } catch (e) {
        this.$root.showSnack('Ошибка сохранения')
        this.$showServerErrors(e)
      }
    },

    openLinkClientDialog() {
      this.clientsDialog = true
    },

    ...mapActions('admin/users', [
      'fetchSingle',
      'linkClient',
      'linkManager',
      'unlinkClient',
      'unlinkManager',
      'update',
      'create'
    ]),

    ...mapMutations('admin/users', ['setClient'])
  },

  computed: {
    ...mapGetters('admin/users', ['isLoading']),
    ...mapState('admin/users', ['client'])
  }
}
</script>
